import React from "react";
import { NavLink } from "react-router-dom";
import { OnyxBrandMark } from "../onyx/OnyxBrandMark";

export const NavBarBrand = () => {
  return (
    <div className="nav-bar__brand">
      <NavLink to="/" className="nav-bar__brand-link" aria-label="Onyx home">
        <OnyxBrandMark size={38} withWordmark />
      </NavLink>
    </div>
  );
};
